import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@breakroom-nx/redux';
import { User } from '@breakroom-nx/classes';

interface ClientState {
  currentUserUID?: string;
  currentUser?: User;
}

const initialState: ClientState = {
  currentUserUID: undefined,
  currentUser: undefined,
};

export const clientSlice = createSlice({
  name: 'client',
  initialState,
  reducers: {
    setCurrentUserUID: (state, action: PayloadAction<string>) => {
      state.currentUserUID = action.payload;
    },
    login: (state, action: PayloadAction<any>) => {
      const user: User = action.payload;
      state.currentUser = user;
    },
    logout: (state) => {
      state.currentUser = undefined;
    },
  },
});

export const { login, logout, setCurrentUserUID } = clientSlice.actions;
export const getCurrentUser = (state: RootState) => state.client.currentUser;
export const getCurrentUserUID = (state: RootState) => state.client.currentUserUID;
export default clientSlice.reducer;
